import {fsa, fsaPayload, fsaError} from './helpers'

export const VALIDATE_EMAIL = 'kickbox/validate email'
export const validateEmail = fsaPayload(VALIDATE_EMAIL)

export const VALIDATE_EMAIL_PENDING = 'kickbox/validate email pending'
export const validateEmailPending = fsa(VALIDATE_EMAIL_PENDING)

export const VALIDATE_EMAIL_SUCCESS = 'kickbox/validate email successful'
export const validateEmailSuccess = fsa(VALIDATE_EMAIL_SUCCESS)

export const VALIDATE_EMAIL_FAILURE = 'kickbox/validate email failure'
export const validateEmailFailure = fsaError(VALIDATE_EMAIL_FAILURE)
